var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { BAlert } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { ref, watch } from "vue";
import { useRouter } from "vue-router/composables";
import { GalaxyApi } from "@/api";
import { useUserStore } from "@/stores/userStore";
import { errorMessageAsString } from "@/utils/simple-error";
import LoadingSpan from "@/components/LoadingSpan.vue";
import WorkflowRun from "@/components/Workflow/Run/WorkflowRun.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowLanding',
    props: {
        uuid: null,
        secret: { default: undefined },
        public: { type: Boolean, default: false }
    },
    setup(__props) {
        const props = __props;
        const workflowId = ref(null);
        const errorMessage = ref(null);
        const requestState = ref(null);
        const instance = ref(false);
        const userStore = useUserStore();
        const router = useRouter();
        userStore.loadUser(false);
        const { isAnonymous, currentUser } = storeToRefs(userStore);
        watch(currentUser, () => __awaiter(this, void 0, void 0, function* () {
            if (isAnonymous.value) {
                router.push(`/login/start?redirect=/workflow_landings/${props.uuid}?public=${props.public}&client_secret=${props.secret}`);
            }
            else if (currentUser.value) {
                let claim;
                let claimError;
                if (props.public) {
                    const { data, error } = yield GalaxyApi().GET("/api/workflow_landings/{uuid}", {
                        params: {
                            path: { uuid: props.uuid },
                        },
                    });
                    claim = data;
                    claimError = error;
                }
                else {
                    const { data, error } = yield GalaxyApi().POST("/api/workflow_landings/{uuid}/claim", {
                        params: {
                            path: { uuid: props.uuid },
                        },
                        body: {
                            client_secret: props.secret,
                        },
                    });
                    claim = data;
                    claimError = error;
                }
                if (claim) {
                    workflowId.value = claim.workflow_id;
                    instance.value = claim.workflow_target_type === "workflow";
                    requestState.value = claim.request_state;
                }
                else {
                    errorMessage.value = errorMessageAsString(claimError);
                }
            }
        }), { immediate: true });
        return { __sfc: true, props, workflowId, errorMessage, requestState, instance, userStore, router, isAnonymous, currentUser, BAlert, LoadingSpan, WorkflowRun };
    }
});
